















































































































































import { DataTableHeader } from "vuetify/types";
import { mapGetters } from "vuex";
import path from "path";
import PosterUser from "../mixins/poster-user";
import StatusChip from "@/components/StatusChip.vue";
import PosterReview from "@/components/PosterReview.vue";
import Presentacion from "@/components/Presentacion.vue";
import PosterUploads from "@/components/PosterUploads.vue";
import DownloadCarta from "@/components/DownloadCarta.vue";
import {
  SimplePoster,
  isModifiablePoster,
  needsUpload,
} from "../models/poster";
import { SimplePosterWithLocales } from "../store/poster";
import API from "../services/api";
import { PosterType } from "../services/poster";
import Swal from "sweetalert2";
import EvaluacionPonencia from "./EvaluacionPonencia.vue";
import EvaluacionPoster from "./EvaluacionPoster.vue";

export interface TablaPosterComponentData {
  posterType?: PosterType;
  reviewPoster?: number | null;
  presentationPoster?: number | null;
  uploadsPoster?: string | number | null;
  evaluationPoster?: string | number | null;
  es_ponencia: boolean;
}

export default PosterUser.extend({
  components: {
    StatusChip,
    PosterReview,
    Presentacion,
    PosterUploads,
    DownloadCarta,
    EvaluacionPonencia,
    EvaluacionPoster,
  },

  props: {
    type: String,
    search: String,
  },

  data(): TablaPosterComponentData {
    return {
      reviewPoster: null,
      presentationPoster: null,
      uploadsPoster: null,
      evaluationPoster: null,
      es_ponencia: false,
    };
  },

  computed: {
    ...mapGetters("shared", ["doing", "featureEnabled"]),
    headers(): DataTableHeader[] {
      const headers = [
        { text: "Id", value: "codigo" },
        { text: "Título", value: "titulo", width: "100%" },
        { text: "Tipo", value: "tipoLocale" },
        this.eval
          ? { text: "Revisión", value: "revision" }
          : { text: "Estado", value: "estado" },
        { text: "Acciones", value: "detailsButton", sortable: false },
      ];

      return headers;
    },

    user(): boolean {
      return this.posterType === "user";
    },

    eval(): boolean {
      return this.posterType === "eval";
    },

    all(): boolean {
      return this.posterType === "all";
    },
  },

  methods: {
    sortItems(
      items: SimplePosterWithLocales[],
      sortBy: string[],
      sortDesc: boolean[]
    ) {
      this.$store.commit("poster/sortPosters", {
        type: this.posterType,
        sortBy,
        sortDesc,
      });
      items.sort(({ index: ai }, { index: bi }) => {
        return typeof ai !== "undefined" && typeof bi !== "undefined"
          ? ai - bi
          : 0;
      });

      return items;
    },

    async details(poster: SimplePoster) {
      await this.fetchPoster(poster);
      if (this.eval || this.all) {
        this.reviewPoster = poster.index;
      } else if (this.user) {
        this.$router.push(`/poster/${poster.id_poster}`);
      }
    },

    async play(poster: SimplePoster) {
      if (!(this.eval || this.all) || !poster._vp) {
        return;
      }

      await this.fetchPoster(poster);
      this.presentationPoster = poster.index;
    },

    async update(poster: SimplePoster) {
      await this.fetchPoster(poster);
      this.$router.push(`/registroposter/${poster.id_poster}`);
    },

    async showUploads({ index }: SimplePoster) {
      this.uploadsPoster = typeof index === "number" ? index : null;
    },

    async plantilla(poster: SimplePoster) {
      const link = this.$refs[`link${poster.id_poster}`] as HTMLLinkElement;
      if (!link || !link.href) {
        return;
      }

      link.click();
    },

    urlPlantilla(poster: SimplePoster) {
      if (
        poster.tipo_aceptacion !== "PST" &&
        poster.tipo_aceptacion !== "PNC"
      ) {
        return;
      }
      const file =
        poster.tipo_aceptacion === "PST"
          ? "Plantillas_Poster.zip"
          : "Plantillas_Ponencia.zip";

      return file && API.getUrl(path.join("/plantillas", file));
    },

    async evaluarPoster(poster: SimplePoster) {
      this.es_ponencia = poster.tipo_aceptacion !== "PST";
      await this.fetchPoster(poster);
      this.evaluationPoster = poster.index;
    },

    isModifiablePoster,
    needsUpload,
    isPdfLoad(item: SimplePoster): boolean {
      return !!item.file;
    },
    mostrarEvaluacion(poster: SimplePoster) {
      return poster.estado === "A" && !poster.calificado;
    },
  },

  created() {
    this.bindPosterType("type");
    const route = this.$route;
    const { hash } = route;
    const match = /^#u(\d+)$/.exec(hash);

    if (!match) {
      return;
    }

    const id = match[1];
    this.uploadsPoster = id;
    this.$router.replace(route.path);
  },
});
